import { render, staticRenderFns } from "./tbguest.vue?vue&type=template&id=087b2f78&scoped=true&"
import script from "./tbguest.vue?vue&type=script&lang=js&"
export * from "./tbguest.vue?vue&type=script&lang=js&"
import style0 from "./tbguest.vue?vue&type=style&index=0&id=087b2f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b2f78",
  null
  
)

export default component.exports